<template>
    <div class="bg-white rounded border-top border-bottom border-cBorder w-100" style="max-width:100%">
        <template>
            <div class="cprimary p-3" v-if="type == `text` && mediaDetails">
           
                <b-row class="" v-if="source === 'list'">
                    <b-col class="text-center p-1 mt-1 mb-md-1 mt-md-2">
                        <h5 class="text-dark font-weight-bold">{{ mediaDetails[colsMaps.title] }}</h5>
                    </b-col>
                    
                </b-row>
                <b-row class="p-2 justify-content-md-center border-bottom text-secondary" v-if="source === 'list'">
                        <b-col cols="6" class="text-center">时间：{{ new Date(mediaDetails[colsMaps.date]).toLocaleDateString()  }}</b-col>
                        <b-col cols="6" class="text-center">发布人：{{ mediaDetails[colsMaps.user] }}</b-col>
                </b-row>
                <b-row class="p-1 p-md-3  rounded-lg border-cBorder">
                    <b-col cols="12" class="">
                        <div class="block" style="text-align: initial;" v-html="recoverFileAddress4richText(`${mediaDetails[colsMaps.content]}`.replace(/\n/g,'<br/>'))">
                        </div>
                    </b-col>
                </b-row>
                <b-row class="p-1 p-md-3  rounded-lg border-cBorder" v-if="mediaDetails['document'] && downloadFiles">
                    <b-col cols="12" class="" v-for="(file,i) in downloadFiles">
                        <div class="block" style="text-align: initial;">
                            <b-icon-download></b-icon-download>[附件] <b-link  @click="download(file)">{{ file.src_name }}  [点击下载]</b-link>
                             
                        </div>
                    </b-col>
                </b-row>
            </div>
        </template>
    </div>
  </template>
  
  <script>
//   import qrCode from '@/assets/qrCode.png'

  import { getListData } from '@/api/api.js'
  export default {
    name: 'detail-layout',
    props: {
        type:{
            type:String,
            default(){
                return 'text'  // text   map   list
            }
        },
        config:{
            type:[Object,Array],
            default(){
                return null
             
            }
        },
        initData:{
            type:[Object,Array],
            default(){
                return null
             
            }
        },
        no:{
            type:String,
            default(){
                return ''  // text   map   list
            }
        },
        colsMaps:{
            type:Object,
            default(){
                return {
                    title:'title',
                    date:'create_time',
                    subTitle:'summary',
                    hot:true,
                    img:'thn_img',
                    content:'content',
                    user:'author_nickname',
                    sign:'author_nickname'
                }
            }
        },


    },
    mounted(){
        if(this.no){
            this.$set(this,'keyVal',this.no)
        }else if(this.$route.params.value){
            this.$set(this,'keyVal',this.$route.params.value)
        }
        
        if(!this.mediaDetails){
            this.getDetail()
        }else{
           
        }

    },
    computed:{
        source() {
            // 从路由查询参数中获取来源标识
            return this.$route.query.source || '';
        },
       
        mediaDetails(){
            let data = this.initData
            if(!data && this.loadData){
                data = this.loadData
            }

            return data
        }
    },
    data() {
      return {
        loadData:null,
        keyVal:null,
        key:'',
        downloadFiles:null
      }
    },
      methods: {
        getDetail(){
            let serviceName = 'srvdaq_pc_website_content_select'
            let req = {
                "serviceName": serviceName,
                "colNames": [
                    "*"
                ],
                "condition": [
                    {
                        "colName": "id",
                        "ruleType": "eq",
                        "value": this.keyVal
                    }
                ],
                "page": {
                    "pageNo": 1,
                    "rownumber": 999
                },
                "order": []
            }
            getListData (req,'ws',serviceName).then(res=>{
                // console.log(res)
                if(res.state == "SUCCESS"){
                    let content = res.data[0]
                    console.log(content, 77777777)
                    this.$set(this,'loadData',content)
                }
            })
        },
        getDownloadInfo(){
            let no = this.mediaDetails['document']
            if(no){
                this.getFileUrls(no).then(res => {
                    console.log(res)
                    if(Array.isArray(res) && res.length > 0){
                        let content = res
                        this.$set(this,'downloadFiles',content)
                    }
                })
            }
            
        },
        download(file){
            let config = this.webConfig
          let hostPath = ''
          if(process.env.NODE_ENV === 'development'){
            hostPath = config.prefix
          }else{
            hostPath = `${config.protocol}://${config.host}${config.port?':'+config.port:''}${config.prefix}`
          }
           let url = hostPath + `/file/download?filePath=${file.fileurl}` 
           console.log(url) 
           window.open(url, '_blank')
        }
    },
    watch:{
        "mediaDetails":{
            deep:true,
            handler:function(nval,oval){
                if(nval){
                    this.getDownloadInfo()
                }
            }
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  